module.exports = __webpack_public_path__ + "img/ublock.2bf49cf9.gif";